import moment from 'moment'

export default class Time {

    // Date is today
    static isToday(date) {
        return moment(date).isSame(moment().clone().startOf('day'), 'd')
    }

    static overdue(date) {
        // Verifica se é uma data válida
        if (moment(date).isValid()) {
            // Verificar se a data atual é maior que a data do ticket
            if (moment(date).isAfter(moment().clone().startOf('minute'))) {
                return false
            } else {
                return true
            }
        }
        return false
    }

    static fromNow(date, type) {

        if(!date || !type) {
            return ''
        }

        if (moment(date).isValid()) {

            // Is Today?
            if (Time.isToday(date)) {
                let dateReturn = moment(date).fromNow().replace('a day', ' 1 dia').replace('an hour', ' 1 hora').replace('a minute', ' 1 minuto');

                dateReturn = dateReturn.replace('days', ' dias').replace('hours', ' horas').replace('minutes', ' minutos');
                dateReturn = dateReturn.replace('day', ' dia').replace('hour', ' hora').replace('minute', ' minuto');
                dateReturn = dateReturn.replace('in ', 'em ').replace('ago', ' atrás');
                dateReturn = dateReturn.replace('a ', '').replace('few', ' poucos');
                dateReturn = dateReturn.replace('seconds ', ' segundos ');
 
                if (type == 'sla_operator') {

                    if (dateReturn.includes('ago')) {
                        return dateReturn.replace('ago', 'overdue');
                    }
                    else {
                        return dateReturn
                    }
                }

                return dateReturn;

                // TODO: Implement to other types
            }
            else {
                const dateMasc = moment(date).format('DD/MM/YYYY : HH:mm');
                if (type == 'sla_operator') {

                    // Check date is overdue
                    if (moment(date).isAfter(moment().clone().startOf('minute'))) {
                        return dateMasc;
                    }
                    else {
                        return dateMasc + ' overdue';
                    }
                }

                return dateMasc;
            }

        }
        else {
            return 'No time'
        }
    }

}
